import React, { useEffect, useState } from 'react';
import Notes from '../components/Notes';
import Events from '../components/Events';
import Filter from '../components/Filter';
import { fetchData } from '../utils/api';
import { generateEndpoint, formatLocaleDate, isSunday, generateInRange } from '../utils/dateUtil';

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);

  const [user, setUser] = useState('');
  const [events, setEvents] = useState([]);

  const [dateGroups, setDateGroups] = useState({});
  const [nameGroups, setNameGroups] = useState({});
  const [staffGroups, setStaffGroups] = useState({});
  const [attendeeGroups, setAttendeeGroups] = useState({});

  const [idLookup, setIdLookup] = useState({});
  const [selectedGroups, setSelectedGroups] = useState({});

  const [selectedFilter, setSelectedFilter] = useState('');
  const [showMyStudentsOnly, setShowMyStudentsOnly] = useState(true);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleFilterChange = (selectedValue) => {
    setSelectedFilter(selectedValue);
  };

  const handleToggleMyStudentsOnly = (checked) => {
    setShowMyStudentsOnly(checked);
  };

  useEffect(() => {
    fetchData(generateEndpoint())
      .then((data) => {
        setEvents(data.event_occurrences);
      })
      .catch((error) => {
        console.log(error);
      });

    fetchData('/desk/staff_members/me')
      .then((data) => {
        localStorage.setItem('user', data.staff_members[0].name);
        setUser(data.staff_members[0].name);
      })
      .catch((error) => {
        localStorage.setItem('user', '');
        console.log(error);
      });
  }, []);

  useEffect(() => {
    let temp = {};
    const eventGroups = {};

    switch (selectedFilter) {
      case 'date':
        temp = dateGroups;
        break;
      case 'name':
        temp = nameGroups;
        break;
      case 'staff':
        temp = staffGroups;
        break;
      case 'student':
        temp = attendeeGroups;
        break;
      default:
        break;
    }

    if (Object.keys(temp).length === 0) return;
    Object.keys(temp).map((key) => (eventGroups[key] = temp[key].map((index) => events[index])));
    setSelectedGroups(eventGroups);
    setIsLoading(false);
  }, [selectedFilter]);

  useEffect(() => {
    if (events.length === 0) return;

    const dateMap = {};
    const nameMap = {};
    const staffMap = {};
    const attendeeMap = {};
    const idMap = {};

    events.forEach((event, index) => {
      const date = formatLocaleDate(event.start_at);
      // if (isSunday(event.start_at)) return; // Commented out to include sessions on Sundays
      if (!dateMap[date]) dateMap[date] = [];
      dateMap[date].push(index);

      if (!nameMap[event.name]) nameMap[event.name] = [];
      nameMap[event.name].push(index);

      event.staff_members.forEach((staff) => {
        if (!staffMap[staff.name]) staffMap[staff.name] = [];
        staffMap[staff.name].push(index);
        if (!idMap[staff.name]) idMap[staff.name] = staff.id;
      });

      event.people.forEach((attendee) => {
        if (!attendeeMap[attendee.name]) attendeeMap[attendee.name] = [];
        attendeeMap[attendee.name].push(index);
        if (!idMap[attendee.name]) idMap[attendee.name] = attendee.id;
      });
    });

    setDateGroups(dateMap);
    setNameGroups(nameMap);
    setStaffGroups(staffMap);
    setAttendeeGroups(attendeeMap);
    setIdLookup(idMap);
    setSelectedFilter('date');
  }, [events]);

  useEffect(() => {
    console.log('startDate', startDate);
    console.log('endDate', endDate);
  }, [startDate, endDate]);

  function refresh() {
    if (startDate < endDate) {
      setIsLoading(true);
      fetchData(generateInRange(startDate, endDate))
        .then((data) => {
          let localDateGroups = {};
          data.event_occurrences.forEach((event, index) => {
            const date = formatLocaleDate(event.start_at);
            if (!localDateGroups[date]) localDateGroups[date] = [];
            localDateGroups[date].push(index);
          });

          const eventGroups = {};
          Object.keys(localDateGroups).map(
            (key) => (eventGroups[key] = localDateGroups[key].map((index) => events[index]))
          );

          console.log('event groups', eventGroups);
          setSelectedGroups(eventGroups);
          setSelectedFilter('date');
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      window.alert('Please double check your data range.');
      setEndDate(new Date());
    }
    setIsLoading(false);
  }

  return (
    <div className="flex flex-col p-2 sm:p-6 justify-center items-center">
      <h1 className="text-2xl font-semibold mb-4 text-zinc-800 dark:text-zinc-100 text-center">
        {user ? `Welcome back, ${user.split(' ')[0]}` : ''}
      </h1>
      {isLoading ? (
        <p className="text-zinc-950 dark:text-zinc-50 text-xl animate-pulse">Loading...</p>
      ) : (
        <>
          <Filter
            selectedFilter={selectedFilter}
            onFilterChange={handleFilterChange}
            onToggleMyStudentsOnly={handleToggleMyStudentsOnly}
            showMyStudentsOnly={showMyStudentsOnly}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
          <button className="bg-cyan-500 p-2 rounded-lg text-white" onClick={refresh}>
            Refresh
          </button>
          <Events groups={selectedGroups} showMyStudentsOnly={showMyStudentsOnly} />
        </>
      )}
    </div>
  );
};

export default Dashboard;
